import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: {
    margin: 0,
    '& + &': {
      marginLeft: 2,
    },
  },
  checkboxRoot: {
    width: 'auto',
    height: 'auto',
    borderRadius: 5,
    color: theme.palette.primary['500'],
  },
  button: {
    textTransform: 'none',
    margin: '0 1px',
    border: `1px solid ${theme.palette.primary['500']}`,
  },
  buttonSelected: {
    color: theme.palette.common.white,
    background: theme.palette.primary['500'],
    borderColor: theme.palette.primary['500'],
  },
});

const CheckboxButtonField = ({
  id, input, label, className, icon, color, size, classes, ...otherProps
}) => (
  <FormControlLabel
    className={classNames(classes.root, className)}
    control={
      <Checkbox
        name={input.name}
        checked={input.value || false}
        onChange={input.onChange}
        classes={{
          root: classes.checkboxRoot,
        }}
        inputProps={{
          id,
        }}
        icon={(
          <Button
            className={classes.button}
            color="primary"
            {...color ? {
              style: {
                color,
                borderColor: color,
              },
            } : {}}
            size={size}
          >
            {icon}
            {label}
          </Button>
        )}
        checkedIcon={(
          <Button
            className={classNames(classes.button, classes.buttonSelected)}
            color="primary"
            size={size}
            {...color ? {
              style: {
                borderColor: color,
                backgroundColor: color,
              },
            } : {}}
          >
            {icon}
            {label}
          </Button>
        )}
        {...otherProps}
      />
    }
  />
);

CheckboxButtonField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    checkboxRoot: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    buttonSelected: PropTypes.string.isRequired,
  }).isRequired,
};

CheckboxButtonField.defaultProps = {
  label: '',
  className: '',
  icon: '',
  color: null,
  size: 'medium',
};

export default withStyles(styles)(CheckboxButtonField);



// WEBPACK FOOTER //
// ./src/components/fields/CheckboxButtonField.js